import * as React from "react";
import { connect } from "react-redux";
import { FillUp } from "@vwpfs/mary-air-lib/components/air/04-helpers/FillUp";
import { Alignment, ButtonsWrapper, Orientation } from "@vwpfs/mary-air-lib/components/air/06-molecules/ButtonsWrapper";
import { Navbar } from "@vwpfs/mary-air-lib/components/air/07-organisms";
import { NavbarStack,
    NavbarStackContent, NavbarStackRight } from "@vwpfs/mary-air-lib/components/air/07-organisms/Navbar/Stack";
import { NavbarTitle } from "@vwpfs/mary-air-lib/components/air/07-organisms/Navbar/Title";
import { NavbarIcon } from "@vwpfs/mary-air-lib/components/air/07-organisms/Navbar/Icon";
import { DispatchFunc } from "../../../../../store/ActionTypes";
import { SubPages } from "../../../../../store/AppDisplays";
import { PolicyRequest } from "../../../../../store/Policies/Types";
import { Products, ProductStatus } from "../../../../../store/Product/Types";
import { ReduxState, isRemoteLoading } from "../../../../../store/ReduxState";
import { RemoteScope } from "../../../../../store/RemoteTypes";
import { ThemeBreakpoints, ThemePalette } from "@vwpfs/mary-air-lib/theme/_Types";
import { modalClose } from "../../../../../utils/redux/ActionTypes";
import { Filter } from "../../02-pages/Filter";
import { Results } from "../../00-blocks/Product/ResultsCreatePolicy";
import { FlexColumn } from "@vwpfs/mary-air-lib/components/air/03-base/Flex/Column";
import { FlexRow } from "@vwpfs/mary-air-lib/components/air/03-base/Flex/Row";
import { Container } from "@vwpfs/mary-air-lib/components/air/03-base/Container";
import { Button } from "@vwpfs/mary-air-lib/components/air/05-atoms/Button";
import { IconNames } from "@vwpfs/mary-air-lib/components/air/05-atoms/Icon";
import { LoadingIndications, LoadingIndicator } from "@vwpfs/mary-air-lib/components/air/05-atoms/LoadingIndicator";

/**
 *
 */
interface OwnProps {
    modalID: string;
    id?: string;
    onChange: <K extends keyof PolicyRequest>(key: K, value: PolicyRequest[K]) => void;
}

interface StateProps {
    results?: Products;
    remoteLoading: boolean;
}

/**
 *
 */
interface DispatchProps {
    closeModal: (id: string) => void;
}

/**
 *
 */
type Props = OwnProps & DispatchProps & StateProps;

/**
 *
 * @param s
 */
export const mapStateToProps = (s: ReduxState): StateProps => ({
    results: s.prop("remote").prop(RemoteScope.PRODUCT_RESULTS),
    remoteLoading: isRemoteLoading(s, RemoteScope.PRODUCT_RESULTS),
});

/**
 *
 */
export const mapDispatchToProps = (dispatch: DispatchFunc): DispatchProps => ({
    closeModal: (id: string) => {
        dispatch(modalClose(id));
    },
});

/**
 *
 */
export class SelectPolicyProductModalComp
    extends React.Component<Props, {}> {

    /**
     *
     * @param props
     * @param ctx
     */
    public constructor(props: Props, ctx?: {}) {
        super(props, ctx);
        this.closeModal = this.closeModal.bind(this);
    }
    /**
     *
     */
    public render() {
        return (
            <FlexColumn
            >
                <FlexRow isFixed>
                    <Navbar
                        theme={{
                            palette: ThemePalette.BRAND_ACCENT,
                        }}
                    >
                        <NavbarStack>
                            <NavbarStackContent>
                                <NavbarTitle>
                                    Select a product
                                </NavbarTitle>
                            </NavbarStackContent>
                            <NavbarStackRight>
                                <NavbarIcon
                                >
                                    <Button
                                        icon={IconNames.TIMES}
                                        link={{ onClick: this.closeModal() }} />
                                </NavbarIcon>
                            </NavbarStackRight>
                        </NavbarStack>
                    </Navbar>
                </FlexRow>
                <FlexRow
                    theme={{
                        palette: ThemePalette.CONTRAST_PRIMARY,
                    }}
                >
                    <FlexColumn
                        style={{
                            maxHeight: "calc(98vh - 120px)",
                        }}
                    >
                        <FlexRow isScrollable>
                            <div style={{ width: "100%" }}>
                                <Filter
                                    collapseFilter
                                    noSpacing
                                    loadingFilters={false}
                                    loadingResults={this.props.remoteLoading}
                                    currentPage={SubPages.POLICY_CREATE}
                                    defaultFilters={{ewStatus: ProductStatus.ACTIVE}}
                                    filterType={"product"}
                                />
                                {this.props.remoteLoading && !this.props.results
                                    ? (
                                        <FillUp>
                                            <Container
                                                theme={{
                                                    padding: {
                                                        "": { y: 3 },
                                                        "md": { y: 4 },
                                                    },
                                                }}
                                            >
                                                <LoadingIndicator
                                                    type={LoadingIndications.DEFAULT}
                                                    theme={{ palette: ThemePalette.BRAND_PRIMARY }}
                                                />
                                            </Container>
                                        </FillUp>
                                    )
                                    : !!this.props.results && (
                                        <Results
                                            results={this.props.results}
                                            onChange={this.props.onChange}
                                            id={this.props.id}
                                        />)}
                            </div>
                        </FlexRow>
                        <FlexRow isFixed>
                            <FlexColumn
                                theme={{
                                    palette: ThemePalette.CONTRAST_TERTIARY,
                                }}
                            >
                                <Container
                                    theme={{
                                        padding: { "": { y: 3 } },
                                    }}
                                >
                                    <ButtonsWrapper
                                        defaultOrientation={Orientation.HORIZONTAL}
                                        orientations={{
                                            [ThemeBreakpoints.XS]: Orientation.VERTICAL,
                                            [ThemeBreakpoints.MD]: Orientation.HORIZONTAL,
                                        }}
                                        alignment={Alignment.RIGHT}
                                    >
                                        <Button
                                            theme={{ palette: ThemePalette.BRAND_ACCENT }}
                                            link={{ onClick: this.closeModal() }}
                                        >
                                            Continue
                                        </Button>
                                    </ButtonsWrapper>
                                </Container>
                            </FlexColumn>
                        </FlexRow>
                    </FlexColumn>
                </FlexRow>
            </FlexColumn>
        );
    }

    private closeModal() {
        return () => this.props.closeModal(this.props.modalID);
    }
}

/**
 *
 */
export const SelectPolicyProductModal = connect(
    mapStateToProps,
    mapDispatchToProps,
)(SelectPolicyProductModalComp);
